<template>
  <div class="text-link text-muted" @click.stop="openSidebar">
    Меню
    <span
      class="icon icon-md icon-current v-align-middle ml-8"
      v-html="require('@/assets/img/icons/hamburger.svg')" />
  </div>
</template>

<script>
  export default {
    name: 'Hamburger',

    methods: {
      openSidebar() {
        document.body.classList.add('sidebar-open')
      }
    }
  }
</script>
